import { useBindApplication } from "@Client/@Composables/application-standalone/useBindApplication";
import { computed } from "@vue/composition-api";
export const useSubjectPropertyFieldBindings = (options = {}) => {
  const existingMortgageIndex = computed(() => {
    var _options$existingMort;
    return (_options$existingMort = options.existingMortgageIndex) == null ? void 0 : _options$existingMort.value;
  });
  const rootPath = "[property]";
  const detailsPath = rootPath + "[details]";
  const costsPath = rootPath + "[costs]";
  const stylesPath = rootPath + "[styles]";
  const existingMortgagePath = computed(() => rootPath + "[existing-mortgages]" + "[" + existingMortgageIndex.value + "]");
  const {
    bindApplication,
    bindAddressField,
    makeFieldPathReactive
  } = useBindApplication();
  const subjectProperty = bindApplication(rootPath);
  const propertyDetailsPurchasePrice = bindApplication(detailsPath + "[purchase-price]", 0);
  const propertyDetailsOccupancy = bindApplication(detailsPath + "[occupancy]", "");
  const propertyDetailsPurchaseDate = bindApplication(detailsPath + "[purchase-date]", "");
  const propertyDetailsLivingSpace = bindApplication(detailsPath + "[living-space]", "");
  const propertyDetailsAppraisedValue = bindApplication(detailsPath + "[appraised-value]", 0);
  const propertyDetailsAppraisalDate = bindApplication(detailsPath + "[appraisal-date]", "");
  const propertyDetailsBlock = bindApplication(detailsPath + "[block]", "");
  const propertyDetailsConcTownship = bindApplication(detailsPath + "[conc-township]", "");
  const propertyDetailsEstimatedValue = bindApplication(detailsPath + "[estimated-value]", 0);
  const propertyDetailsLot = bindApplication(detailsPath + "[lot]", "");
  const propertyDetailsMlsListing = bindApplication(detailsPath + "[mls-listing]", "");
  const propertyDetailsMonthlyIncome = bindApplication(detailsPath + "[monthly-income]", "");
  const propertyDetailsPropertyValueIndex = bindApplication(detailsPath + "[property-value-index]", "");
  const propertyDetailsRentalProperty = bindApplication(detailsPath + "[rental-property]", "");
  const propertyDetailsAddressProvince = bindApplication(detailsPath + "[address][province]", "");
  const propertyAddress = bindAddressField(detailsPath + "[address]");
  const propertyStylePropertyStyle = bindApplication(stylesPath + "[property-style]", "");
  const propertyStyleConstructionType = bindApplication(stylesPath + "[construction-type]", "");
  const propertyStyleEnvironmentalHazard = bindApplication(stylesPath + "[environmental-hazard]", null);
  const propertyStyleHeat = bindApplication(stylesPath + "[heat]", "");
  const propertyStyleLotSize = bindApplication(stylesPath + "[lot-size]", "");
  const propertyStyleGarageStyle = bindApplication(stylesPath + "[garage-style]", "");
  const propertyStyleLotSizeType = bindApplication(stylesPath + "[lot-size-type]", "");
  const propertyStyleNumberOfUnits = bindApplication(stylesPath + "[number-of-units]", "");
  const propertyStyleSewageInfo = bindApplication(stylesPath + "[sewage-info]", "");
  const propertyStyleStructureAge = bindApplication(stylesPath + "[structure-age]", "");
  const propertyStyleTenure = bindApplication(stylesPath + "[tenure]", "");
  const propertyStyleWaterInfo = bindApplication(stylesPath + "[water-info]", "");
  const propertyStylePropertyType = bindApplication(stylesPath + "[property-type]", "");
  const propertyStyleGarageSize = bindApplication(stylesPath + "[garage-size]", "");
  const propertyCostsFeesIncludeHeat = bindApplication(costsPath + "[fees-include-heat]", null);
  const propertyCostsHeating = bindApplication(costsPath + "[heating]", 0);
  const propertyCostsHydro = bindApplication(costsPath + "[hydro]", 0);
  const propertyCostsIncludeInTds = bindApplication(costsPath + "[include-in-tds]", null);
  const propertyCostsInsurance = bindApplication(costsPath + "[insurance]", 0);
  const propertyCostsInterest = bindApplication(costsPath + "[interest]", 0);
  const propertyCostsMaintenanceFees = bindApplication(costsPath + "[maintenance-fees]", 0);
  const propertyCostsManagement = bindApplication(costsPath + "[management]", 0);
  const propertyCostsOthers = bindApplication(costsPath + "[others]", 0);
  const propertyCostsPercOfTotalMaintFees = bindApplication(costsPath + "[perc-of-total-maint-fees]", "");
  const propertyCostsPropertyTaxes = bindApplication(costsPath + "[property-taxes]", 0);
  const propertyCostsRentalIncomeOptions = bindApplication(costsPath + "[rental-income-options]", "");
  const propertyCostsRentalIncomeOptionsPercent = bindApplication(costsPath + "[rental-income-options-percent]", "");
  const propertyCostsRepairs = bindApplication(costsPath + "[repairs]", 0);
  const propertyCostsTaxResponsible = bindApplication(costsPath + "[tax-responsible]", "");
  const propertyCostsTaxYear = bindApplication(costsPath + "[tax-year]", "");
  const existingMortgageBalanceRemaining = bindApplication(makeFieldPathReactive(existingMortgagePath, "[balance-remaining]"), "");
  const existingMortgageBlendedAmortization = bindApplication(makeFieldPathReactive(existingMortgagePath, "[blended-amortization]"), null);
  const existingMortgageCurrentMortgageNumber = bindApplication(makeFieldPathReactive(existingMortgagePath, "[current-mortgage-number]"), "");
  const existingMortgageFrequency = bindApplication(makeFieldPathReactive(existingMortgagePath, "[frequency]"), "");
  const existingMortgageInsured = bindApplication(makeFieldPathReactive(existingMortgagePath, "[insured]"), null);
  const existingMortgageInterestRate = bindApplication(makeFieldPathReactive(existingMortgagePath, "[interest-rate]"), "");
  const existingMortgageLender = bindApplication(makeFieldPathReactive(existingMortgagePath, "[lender]"), "");
  const existingMortgageLoanType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[loan-type]"), "");
  const existingMortgageMaturityDate = bindApplication(makeFieldPathReactive(existingMortgagePath, "[maturity-date]"), "");
  const existingMortgageMortgageInsuranceProviderId = bindApplication(makeFieldPathReactive(existingMortgagePath, "[mortgage-insurance-provider-id]"), "");
  const existingMortgageMortgageType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[mortgage-type]"), "");
  const existingMortgageOrigAmount = bindApplication(makeFieldPathReactive(existingMortgagePath, "[orig-amount]"), "");
  const existingMortgagePaymentAmount = bindApplication(makeFieldPathReactive(existingMortgagePath, "[payment-amount]"), "");
  const existingMortgagePayoff = bindApplication(makeFieldPathReactive(existingMortgagePath, "[payoff]"), "");
  const existingMortgageRateType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[rate-type]"), "");
  const existingMortgageTermType = bindApplication(makeFieldPathReactive(existingMortgagePath, "[term-type]"), "");
  const existingMortgageRefiAdditionalInfo = bindApplication(makeFieldPathReactive(existingMortgagePath, "[refi-additional-info]"), "");
  const existingMortgageInsuranceAccountNumber = bindApplication(makeFieldPathReactive(existingMortgagePath, "[insurance-account-number]"), "");
  return {
    subjectProperty,
    propertyDetailsPurchasePrice,
    propertyDetailsOccupancy,
    propertyDetailsPurchaseDate,
    propertyDetailsLivingSpace,
    propertyDetailsAppraisedValue,
    propertyDetailsAppraisalDate,
    propertyDetailsBlock,
    propertyDetailsConcTownship,
    propertyDetailsEstimatedValue,
    propertyDetailsLot,
    propertyDetailsMlsListing,
    propertyDetailsMonthlyIncome,
    propertyDetailsPropertyValueIndex,
    propertyDetailsRentalProperty,
    propertyStylePropertyStyle,
    propertyStylePropertyType,
    propertyStyleGarageSize,
    propertyStyleConstructionType,
    propertyStyleEnvironmentalHazard,
    propertyStyleHeat,
    propertyStyleLotSize,
    propertyStyleGarageStyle,
    propertyStyleLotSizeType,
    propertyStyleNumberOfUnits,
    propertyStyleSewageInfo,
    propertyStyleStructureAge,
    propertyStyleTenure,
    propertyStyleWaterInfo,
    propertyAddress,
    propertyDetailsAddressProvince,
    propertyCostsFeesIncludeHeat,
    propertyCostsHeating,
    propertyCostsHydro,
    propertyCostsIncludeInTds,
    propertyCostsInsurance,
    propertyCostsInterest,
    propertyCostsMaintenanceFees,
    propertyCostsManagement,
    propertyCostsOthers,
    propertyCostsPercOfTotalMaintFees,
    propertyCostsPropertyTaxes,
    propertyCostsRentalIncomeOptions,
    propertyCostsRentalIncomeOptionsPercent,
    propertyCostsRepairs,
    propertyCostsTaxResponsible,
    propertyCostsTaxYear,
    existingMortgageBalanceRemaining,
    existingMortgageBlendedAmortization,
    existingMortgageCurrentMortgageNumber,
    existingMortgageFrequency,
    existingMortgageInsured,
    existingMortgageInterestRate,
    existingMortgageLender,
    existingMortgageLoanType,
    existingMortgageMaturityDate,
    existingMortgageMortgageInsuranceProviderId,
    existingMortgageMortgageType,
    existingMortgageOrigAmount,
    existingMortgagePaymentAmount,
    existingMortgagePayoff,
    existingMortgageRateType,
    existingMortgageTermType,
    existingMortgageRefiAdditionalInfo,
    existingMortgageInsuranceAccountNumber
  };
};